import { StateCreator } from 'zustand';
import type { Character } from '../../../types/character';
import { validateCharacter, ValidationResult } from '../../../types/validation';

export interface ValidationSlice {
  validate: () => ValidationResult;
}

interface CharacterStore extends ValidationSlice {
  character: Character | null;
  _setValidationErrors: (errors: string[]) => void;
}

export const createValidationSlice: StateCreator<CharacterStore, [], [], ValidationSlice> = (
  set,
  get
) => ({
  validate: () => {
    const { character, _setValidationErrors } = get();
    if (!character) {
      return { success: false, errors: ['No character loaded'] };
    }

    const result = validateCharacter(character);
    _setValidationErrors(result.errors);
    return result;
  }
});
